import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { COLORS, BREAKPOINTS, FONTS } from '../utils/styleConstants';
import sidebarLogo from '../assets/sidebar_logo.svg';
import { useAuth } from '../context/AuthContext';
import expedientesLogo from '../assets/aaff OV_logo_rgb_1000px_MIS EXPEDIENTES.png';
import expedientesLogoW from '../assets/aaff OV_logo_rgb_1000px_MIS EXPEDIENTES W.png';
import ofertaSimbolo from '../assets/aaff OV_logo_rgb_1000px SIMBOLO 02.svg';
import userLogo from '../assets/aaff OV_logo_rgb_1000px_USER.png';
import buyOfferTop from '../assets/buy_offer_top.png';
import buyOfferDown from '../assets/buy_offer_down.png';
import { useState, useEffect } from 'react';
import { useCredits } from '../context/CreditsContext';
import CreditsDisplay from './CreditsDisplay.js';

const SidebarContainer = styled.div`
  width: 122px;
  background-color: #01174f;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  position: relative;

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    width: 100%;
    height: 70px;
    padding: 1rem;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #01174f;
  }
`;

const Logo = styled.img`
  width: 40px;
  height: auto;
  margin-bottom: 4rem;

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    width: 30px;
    margin-bottom: 0;
    margin-left: 1rem;
  }
`;

const NavSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 2rem;
  
  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    display: none;
  }
`;

const NavItem = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-decoration: none;
  color: white;
  width: 100%;
  padding: 0.75rem 0;
  margin-bottom: 1.5rem;
  border-radius: 4px;
  transition: background-color 0.2s;
  position: relative;
  
  &:hover {
    opacity: 0.9;
  }
  
  ${props => props.$active && `
    &::before {
      content: '';
      position: absolute;
      left: -1rem;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 70%;
      background-color: #86A9D5;
      border-radius: 0 2px 2px 0;
    }
  `}
`;

const NewOfferNavItem = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-decoration: none;
  color: white;
  width: 100%;
  padding: 0.75rem 0;
  margin-bottom: 1.5rem;
  border-radius: 4px;
  transition: background-color 0.2s;
  position: relative;
  
  &:hover {
    opacity: 0.9;
  }
  
  ${props => props.$active && `
    &::before {
      content: '';
      position: absolute;
      left: -1rem;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 70%;
      background-color: #ff7057; // Orange color
      border-radius: 0 2px 2px 0;
    }
  `}
`;

const PurchaseNavItem = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-decoration: none;
  color: white;
  width: 100%;
  padding: 0.75rem 0;
  margin-bottom: 1.5rem;
  border-radius: 4px;
  transition: background-color 0.2s;
  position: relative;
  
  &:hover {
    opacity: 0.9;
  }
  
  ${props => props.$active && `
    &::before {
      content: '';
      position: absolute;
      left: -1rem;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 70%;
      background-color: #ff7057;
      border-radius: 0 2px 2px 0;
    }
  `}
`;

const NavIcon = styled.div`
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 24px;
  height: 24px;
`;

const NavImage = styled.img`
  width: 24px;
  height: auto;
`;

const NavLabel = styled.span`
  font-size: 0.73rem;
  text-align: left;
  font-family: ${FONTS.RETINA};
  max-width: 90%;
  font-weight: normal;
  color: ${props => props.$active ? '#86A9D5' : 'white'};
`;

const PurchaseNavLabel = styled.span`
  font-size: 0.73rem;
  text-align: left;
  font-family: ${FONTS.RETINA};
  max-width: 90%;
  font-weight: normal;
  color: ${props => props.$active ? '#ff7057' : 'white'};
`;

const ProfileSection = styled(Link)`
  position: absolute;
  bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.9;
  }
  
  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    display: none;
  }
`;

const ProfileIcon = styled.div`
  width: 46px;
  height: 46px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
  font-weight: bold;
  color: #01174f;
  font-size: 1.2rem;
`;

const ProfileName = styled.span`
  color: white;
  font-size: 0.8rem;
  text-align: center;
  font-family: ${FONTS.RETINA};
  font-weight: normal;
`;

const MobileNavToggle = styled.div`
  display: none;
  
  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    display: flex;
    margin-left: auto;
    padding-right: 1rem;
  }
`;

// SVG Icons
const FilesIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="16" height="16" rx="1" stroke="white" strokeWidth="1.5"/>
  </svg>
);

const NewOfferIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="16" height="16" rx="1" stroke="white" strokeWidth="1.5"/>
    <path d="M12 8V16" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 12H16" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Estilo para el SVG de Nueva Oferta Vinculante (blanco)
const WhiteIconImage = styled.img`
  width: 24px;
  height: auto;
  filter: brightness(0) invert(1); /* Hace el SVG blanco */
`;

// Estilo para el SVG de Nueva Oferta Vinculante (azul activo)
const BlueIconImage = styled.img`
  width: 24px;
  height: auto;
  filter: brightness(0) saturate(100%) invert(62%) sepia(11%) saturate(1157%) hue-rotate(179deg) brightness(88%) contrast(88%); /* Color #86A9D5 */
`;

const OrangeIconImage = styled.img`
  width: 24px;
  height: auto;
`;

const NewOfferNavLabel = styled.span`
  font-size: 0.73rem;
  text-align: left;
  font-family: ${FONTS.RETINA};
  max-width: 90%;
  font-weight: normal;
  color: ${props => props.$active ? '#ff7057' : 'white'}; // Orange when active
`;



// Estilo para el ícono de usuario
const UserImage = styled.img`
  width: 46px;
  height: 46px;
  margin-bottom: 0.75rem;
`;

// Estilos para los triángulos del botón de comprar ofertas
const BuyOfferTop = styled.img`
  width: 30px;
  height: auto;
  filter: ${props => props.$active ? 'brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(346deg) brightness(118%) contrast(119%)' : 'brightness(0) invert(1)'};
`;

const BuyOfferDown = styled.img`
  width: 30px;
  height: auto;
  filter: ${props => props.$active ? 'brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(346deg) brightness(118%) contrast(119%)' : 'brightness(0) invert(1)'};
`;

// Nuevo ícono para comprar ofertas (ícono de tarjeta de crédito)
const CreditCardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="6" width="20" height="12" rx="2" stroke="white" strokeWidth="1.5"/>
    <path d="M2 10H22" stroke="white" strokeWidth="1.5"/>
    <rect x="6" y="14" width="4" height="2" fill="white"/>
  </svg>
);

// Contenedor para mostrar créditos disponibles
const CreditsInfo = styled.div`
  font-size: 0.65rem;
  color: #ff7057;
  text-align: center;
  margin-top: 0.25rem;
  font-family: ${FONTS.PRIMARY};
  font-weight: 500;
  white-space: nowrap;
`;

const Sidebar = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { credits, isLoading } = useCredits();
  
  // Get user's first name or username for display
  const getDisplayName = () => {
    if (!user) return 'Usuario';
    
    // Priorizar first_name
    if (user.first_name) return user.first_name;
    
    // Fallback a otros campos de nombre
    if (user.firstName) return user.firstName;
    if (user.name) return user.name;
    if (user.username) return user.username;
    
    // Como último recurso, usar Usuario por defecto
    return 'Usuario';
  };
  
  // Get user's initials for profile icon
  const getInitials = () => {
    if (!user) return 'U';
    
    // Priorizar first_name y last_name
    if (user.first_name && user.last_name) {
      return `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase();
    }
    
    // Solo first_name disponible
    if (user.first_name) {
      return user.first_name.charAt(0).toUpperCase();
    }
    
    // Fallback a otros campos de nombre
    if (user.firstName && user.lastName) {
      return `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase();
    }
    
    // If we have name with spaces
    if (user.name && user.name.includes(' ')) {
      const nameParts = user.name.split(' ');
      return `${nameParts[0].charAt(0)}${nameParts[1].charAt(0)}`.toUpperCase();
    }
    
    const name = getDisplayName();
    return name.charAt(0).toUpperCase();
  };
  
  // Check if the current path matches a given path
  const isActive = (path) => {
    const currentPath = location.pathname;
    
    if (path === '/offers') {
      return currentPath === '/' || currentPath === '/offers';
    }
    if (path === '/nueva-oferta') {
      return currentPath.includes('/nueva-oferta') || currentPath.includes('/editar-oferta');
    }
    if (path === '/purchase') {
      return currentPath === '/purchase';
    }
    
    return currentPath === path;
  };
  
  // Add effect to log when clicking the link
  const handleExpedientesClick = (e) => {
    const currentPath = location.pathname;
    
    if (currentPath === '/' || currentPath === '/offers') {
      e.preventDefault();
      window.location.reload();
    }
  };



  return (
    <SidebarContainer>
      <Logo src={sidebarLogo} alt="Logo" />
      
      <NavSection>
        <NavItem 
          to="/offers" 
          $active={isActive('/offers')}
          onClick={handleExpedientesClick}
        >
          <NavIcon>
            <NavImage 
              src={isActive('/offers') ? expedientesLogo : expedientesLogoW} 
              alt="Mis Expedientes" 
            />
          </NavIcon>
          <NavLabel $active={isActive('/offers')}>
            Mis<br />Expedientes
          </NavLabel>
        </NavItem>

        <NewOfferNavItem 
          to="/nueva-oferta" 
          $active={isActive('/nueva-oferta')}
        >
          <NavIcon>
            {isActive('/nueva-oferta') ? (
              <OrangeIconImage src={ofertaSimbolo} alt="Nueva Oferta" />
            ) : (
              <WhiteIconImage src={ofertaSimbolo} alt="Nueva Oferta" />
            )}
          </NavIcon>
          <NewOfferNavLabel $active={isActive('/nueva-oferta')}>
            Nueva Oferta<br />Vinculante
          </NewOfferNavLabel>
        </NewOfferNavItem>

        <PurchaseNavItem 
          to="/purchase" 
          $active={isActive('/purchase')}
        >
          <BuyOfferTop 
            src={buyOfferTop} 
            alt="Comprar ofertas arriba" 
            $active={isActive('/purchase')}
          />
          <PurchaseNavLabel $active={isActive('/purchase')}>
            Comprar<br />Nuevas Ofertas
          </PurchaseNavLabel>
          <BuyOfferDown 
            src={buyOfferDown} 
            alt="Comprar ofertas abajo" 
            $active={isActive('/purchase')}
          />
        </PurchaseNavItem>
      </NavSection>
      
      <ProfileSection to="/profile/edit">
        <UserImage src={userLogo} alt="Usuario" />
        <ProfileName>{getDisplayName()}</ProfileName>
      </ProfileSection>
      
      <MobileNavToggle>
        <span style={{color: 'white', fontSize: '1.5rem'}}>≡</span>
      </MobileNavToggle>
    </SidebarContainer>
  );
};

export default Sidebar; 